const StarIcon = (props) => {
    return (
        props.icon
    );
};

export default StarIcon;